import * as React from "react";
import { MapClustersTypes } from "../MapClusters/MapClusters";

export interface IRadiusProps {
  key?: string;
  height: number;
  width: number;
  onMouseOver?: any;
  onMouseOut?: any;
  mapClusterType?: MapClustersTypes;
}

export const Radius = (props: IRadiusProps) => {
  const { key, height, width, onMouseOver, onMouseOut, mapClusterType } = props
  const style = { height, width };
  return <div key={key} onMouseOver={onMouseOver} onMouseOut={onMouseOut} className={`radius-container radius-marker ${mapClusterType === MapClustersTypes.ALERTS ? 'radius-alert' : ''}`} style={style} />;
};



// WEBPACK FOOTER //
// ./src/share/components/Maps/common/Radius.tsx